import { PWBHost } from "promise-worker-bi";
import { HostWorkerBase } from "./host-worker-base";
import { BOTSTATE, EWorker, IMessageWorker, WORKER_PING_TIME } from "./defs";
import { LeanbotSleep } from "../../public/common/js/api/util";

// mobile doesnt support shareworker, we disable this by add a fake do nothing
class FakeShareWorker extends Worker {

}
/**
 * This only used for the pc gateway page
 */
export class BluetoothHostShareWorker extends HostWorkerBase {
   
    private bluetoothThread: PWBHost;
    // async setBotState(state: EWorker) {
    //     await this.worker.postMessage({type:EWorker.SET_BOT_STATE,data: state});
    // }


    constructor(bluetooth:PWBHost) {
        super();
        var wk ;
        
        if (typeof(SharedWorker)=="undefined") {
            var script="console.log('no shared worker !!!')"
            var blob = new Blob([script], {type: 'application/javascript'});
            wk = new FakeShareWorker(URL.createObjectURL(blob), { type: 'module' });
        } else {
            wk = new SharedWorker(
                new URL('./share-bluetooth-api-thread', import.meta.url),
                { type: 'module' }
            );
        }
     
        this.worker = new PWBHost(wk as any);
        this.bluetoothThread=bluetooth;
        this.setupEventHandlers();
        
    }
    private setupEventHandlers() {
        const pingPong=async ()=>{
            await this.worker.postMessage({type:EWorker.CMD_PING});
            // await LeanbotSleep(WORKER_PING_TIME);
            setTimeout(()=>pingPong(),WORKER_PING_TIME);
        }
        // notify the host we are alive
        pingPong();


        // this is event handler for pc gateway page
        this.worker.register(async (message:any) => {

            switch (message.type) {
                case EWorker.CMD_DISCONNECT_REQUEST:
                    await this.sendMessageToBluetoothThread({type:EWorker.CMD_DISCONNECT});
                    break;
                case EWorker.CMD_HOST_START_BOT:
                    await this.sendMessageToBluetoothThread({type:EWorker.CMD_WORKER_START_BOT});
                    break;
                case EWorker.CMD_HOST_SEND_DATA:
                    await this.sendMessageToBluetoothThread({type:EWorker.CMD_WORKER_SEND_DATA,data:message.data});
                    break;
            }
            console.log("share host event:",message)
            await Promise.resolve();
          });
    }
    async sendMessageToBluetoothThread(message:IMessageWorker) {
        if (this.bluetoothThread) {
            await this.bluetoothThread.postMessage(message);
        }
    }
    get host() {
        return this.worker._hostID;
    }
    async sendData(data:Uint8Array) {
        
        await this.worker.postMessage({type:EWorker.CMD_WORKER_SEND_DATA,data:data});
        
    }
    async startBot() {
        
        await this.worker.postMessage({type:EWorker.CMD_WORKER_START_BOT});
        
    }
    async getCurrentBot() {
        return await this.worker.postMessage({type:EWorker.CMD_GET_CURRENT_BOT});
    }
    // set bot host to -1
    async removeCurrentBot() {
        await this.worker.postMessage({type:EWorker.CMD_DISCONNECT_CURRENT_BOT});
    }
   
    async setCurrentBot() {
        // debugger;
        await this.worker.postMessage({type:EWorker.CMD_SET_CURRENT_BOT});
    }
    async broadcastDisconnectBot() {
        // return new Promise((resolve))
        await this.worker.postMessage({type:EWorker.CMD_DISCONNECT});
    }

}
/**
 * this will be used to send message to shared worker from cross tab
 */
export const sharedWorkerCrossTab = new BluetoothHostShareWorker(null);
